const C = {
  surface: "var(--bc-panel, #18181B)", highlight: "var(--bc-panel-elev, #27272A)", border: "var(--bc-border, #27272A)",
  text: "var(--bc-ink, #FAFAFA)", muted: "var(--bc-sub, #A1A1AA)", green: "#22C55E",
  red: "#EF4444", yellow: "#F59E0B",
};

const RESULT_STYLE = {
  W: { bg: "rgba(34,197,94,0.15)", color: "#22C55E", border: "1px solid rgba(34,197,94,0.3)" },
  D: { bg: "rgba(161,161,170,0.1)", color: "var(--bc-sub, #A1A1AA)", border: "1px solid rgba(161,161,170,0.2)" },
  L: { bg: "rgba(239,68,68,0.12)", color: "#EF4444", border: "1px solid rgba(239,68,68,0.25)" },
};

function StatRow({ label, value, highlight }) {
  return (
    <div className="flex justify-between items-center py-1.5" style={{ borderBottom: `1px solid ${C.highlight}` }}>
      <span className="text-xs" style={{ color: C.muted, fontFamily: "DM Sans, sans-serif" }}>{label}</span>
      <span className="font-data text-xs font-medium" style={{ color: highlight ? C.green : C.text }}>{value}</span>
    </div>
  );
}

export default function FormGuide({ team, form, stats, side }) {
  const last5 = form.slice(0, 5);
  const totalPlayed = stats.wins + stats.draws + stats.losses;
  const winPct = totalPlayed > 0 ? Math.round((stats.wins / totalPlayed) * 100) : 0;

  return (
    <div style={{ background: C.surface, border: `1px solid ${C.border}` }} data-testid={`form-guide-${side}`}>
      {/* Header */}
      <div className="flex items-center gap-3 px-4 py-3" style={{ borderBottom: `1px solid ${C.border}` }}>
        <div className="w-8 h-8 flex-shrink-0">
          <img src={team.logo} alt={team.name} className="w-full h-full object-contain"
            onError={(e) => e.target.style.display = "none"} />
        </div>
        <div>
          <p className="font-heading font-bold text-sm uppercase tracking-tight" style={{ color: C.text }}>{team.name}</p>
          <p className="font-data text-xs" style={{ color: C.muted }}>
            {side === "home" ? "CASA" : "TRASFERTA"} · {totalPlayed} GARE
          </p>
        </div>
      </div>

      {/* Last 5 form */}
      <div className="px-4 py-3" style={{ borderBottom: `1px solid ${C.border}` }}>
        <p className="font-data text-xs uppercase tracking-widest mb-2" style={{ color: C.muted }}>FORMA RECENTE</p>
        <div className="flex gap-1.5">
          {last5.length > 0 ? last5.map((m, i) => (
            <div key={i} className="flex flex-col items-center gap-1">
              <div
                className="w-8 h-8 flex items-center justify-center font-heading font-bold text-sm"
                style={RESULT_STYLE[m.result] || RESULT_STYLE.D}
                title={`${m.result} vs ${m.opponent} (${m.scored}-${m.conceded})`}
              >
                {m.result}
              </div>
              <span className="font-data text-xs" style={{ color: C.muted, fontSize: "0.6rem" }}>
                {m.scored}-{m.conceded}
              </span>
            </div>
          )) : (
            <span className="font-data text-xs" style={{ color: C.muted }}>Nessun dato</span>
          )}
          {/* Empty slots */}
          {Array(Math.max(0, 5 - last5.length)).fill(null).map((_, i) => (
            <div key={`e-${i}`} className="w-8 h-8 flex items-center justify-center"
              style={{ background: C.highlight, border: `1px solid ${C.border}` }}>
              <span style={{ color: C.muted, fontSize: "0.6rem" }}>-</span>
            </div>
          ))}
        </div>
      </div>

      {/* Stats */}
      <div className="px-4 py-3">
        <StatRow label="Media Gol Segnati" value={stats.avg_scored} highlight />
        <StatRow label="Media Gol Subiti" value={stats.avg_conceded} />
        <StatRow label="Vittorie / Pareggi / Sconfitte" value={`${stats.wins}W / ${stats.draws}D / ${stats.losses}L`} />
        <StatRow label="Percentuale Vittorie" value={`${winPct}%`} />
        <div className="flex justify-between items-center py-1.5">
          <span className="text-xs" style={{ color: C.muted, fontFamily: "DM Sans, sans-serif" }}>Tot. Gol Segnati / Subiti</span>
          <span className="font-data text-xs font-medium" style={{ color: C.text }}>
            {stats.total_scored} / {stats.total_conceded}
          </span>
        </div>
      </div>
    </div>
  );
}
